import React from 'react';
import { AppContainer } from '../UI/Container';
import { SizedBox } from '../UI/Sizes';
import useTheme from '../../hooks/useTheme';
import AppText from '../UI/Texts/AppTexts';
import AppFooter from '../Footers/AppFooter';

const TermsPage = () => {
    const theme = useTheme();
    return (
        <div>
            <AppContainer>
                <SizedBox height={theme.spacing.elementPadding} />
                <AppText.HeadingBig use={'h1'}>{"Allmänna villkor för Staffi"}</AppText.HeadingBig>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.SubHeading fontWeight={600} use={'h2'} margins={{
                    marginTop: '0px',
                    marginBottom: '0px'
                }} >{"1. Allmänt och definitioner"}</AppText.SubHeading>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.BodyText>
                    {`1.1 Dessa användarvillkor för vårdarbetare ("Användarvillkoren") gäller för användning av den tjänst som vid var tid tillhandahålls av Medalla AB, org. nr 559224-7893 ("Medalla").`}
                </AppText.BodyText>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.BodyText>
                    {`1.2 Medalla tillhandahåller en app vid namn Staffi ("Appen"). I appen kan vårdpersonal ("Användaren") se uppdrag som förmedlas av bemanningsbolag ("Partners").`}
                </AppText.BodyText>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.BodyText>
                    {`1.3 När Användaren registrerar sitt användarkonto accepterar Användaren också Användarvillkoren, som tillsammans med Användarens registrering av användarkontot utgör avtalet mellan Användaren och Medalla ("Avtalet").`}
                </AppText.BodyText>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.SubHeading fontWeight={600} use={'h2'} margins={{
                    marginTop: '0px',
                    marginBottom: '0px'
                }} >{"2. Användarkonto och behörighet"}</AppText.SubHeading>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.BodyText>
                    {`2.1 Användaren kan se och ansöka om uppdrag utan att skapa konto. För att användaren ska se information om arbetsplatsen där uppdraget ska utföras måste Användaren skapa ett konto. Användaren ansvarar för att informationen som lämnas vid registrering är riktig, uppdaterad och fullständig. Användarkontot är personligt, och Användaren får inte ge någon annan tillgång till Tjänsten genom användarkontot.`}
                </AppText.BodyText>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.BodyText>
                    {`2.2 För att vara behörig att använda Tjänsten måste Användaren arbeta inom vården.`}
                </AppText.BodyText>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.BodyText>
                    {`2.3 För att Användaren ska verifiera sig i Tjänsten kommer Medalla att kontrollera att Användaren är legitimerad som hälso- och sjukvårdspersonal. Medalla gör en kontroll mot Registret över legitimerad hälso- och sjukvårdspersonal (HoSp). Medalla kan efter eget gottfinnande neka Användaren att använda Tjänsten baserat på utfallet av ovan nämnda kontroll.`}
                </AppText.BodyText>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.SubHeading fontWeight={600} use={'h2'} margins={{
                    marginTop: '0px',
                    marginBottom: '0px'
                }} >{"3. Ansvar vid anställning hos vårdgivare"}</AppText.SubHeading>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.BodyText>
                    {`3.1 Tjänsten ger Användaren möjlighet visa intresse för uppdrag via Partners. Du måste vara minst 18 år för att få använda Tjänsten. Tjänsten har ingen del i anställningsprocessen mellan dig och en eventuell arbetsgivare, förutom den inledande kontakten.`}
                </AppText.BodyText>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.BodyText>
                    {`3.2 Användare väljer själva om dom vill ta uppdrag av en Partner som denne kommit i kontakt med via Tjänsten. Medalla tar inom denna del av Tjänsten inget ansvar för Partners agerande gentemot Användare.`}
                </AppText.BodyText>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.SubHeading fontWeight={600} use={'h2'} margins={{
                    marginTop: '0px',
                    marginBottom: '0px'
                }} >{"4. Licens till Appen"}</AppText.SubHeading>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.BodyText>
                    {`4.1 Förutsatt att Användaren uppfyller Användarvillkoren så ger Medalla Användaren en icke-exklusiv och icke-överlåtbar rätt att använda Tjänsten via sitt användarkonto samt att använda Appen på sin Android- eller iOS-enhet.`}
                </AppText.BodyText>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.SubHeading fontWeight={600} use={'h2'} margins={{
                    marginTop: '0px',
                    marginBottom: '0px'
                }} >{"5. Ansvarsbegränsning och skadeslöshet"}</AppText.SubHeading>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.BodyText>
                    {`5.1 Tjänsten och Appen tillhandahålls i befintligt skick utan garantier av något slag och användningen av Tjänsten är Användarens ansvar. Medalla lämnar inte några garantier, direkta, underförstådda eller på annat sätt, rörande tillgänglighet, kvalitet, duglighet för något särskilt syfte, lämplighet eller riktighet av Tjänsten och Appen.`}
                </AppText.BodyText>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.SubHeading fontWeight={600} use={'h2'} margins={{
                    marginTop: '0px',
                    marginBottom: '0px'
                }} >{"6. Personuppgifter"}</AppText.SubHeading>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.BodyText>
                    {`6.1 Medalla är personuppgiftsansvarig för behandlingen av Användarens personuppgifter som samlas in i samband med skapande av konto och vid användning av Tjänsten. Medalla behandlar personuppgifterna i enlighet med personuppgiftslagen (1998:204) eller, efter den 24 maj 2018, Dataskyddsförordningen (EU 2016/679) och Medallas dataskyddspolicy.`}
                </AppText.BodyText>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.SubHeading fontWeight={600} use={'h2'} margins={{
                    marginTop: '0px',
                    marginBottom: '0px'
                }} >{"7. Immateriella rättigheter"}</AppText.SubHeading>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.BodyText>
                    {`7.1 All upphovsrätt, varumärken och andra immateriella rättigheter (registrerade och oregistrerade) i Tjänsten och Appen tillhör Medalla och/eller tredje man. Ingenting i Användarvillkoren ger Användaren en rättighet eller licens att använda någon upphovsrätt, varumärke, eller annan immateriell rättighet som ägs eller kontrolleras av Medalla.`}
                </AppText.BodyText>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.SubHeading fontWeight={600} use={'h2'} margins={{
                    marginTop: '0px',
                    marginBottom: '0px'
                }} >{"8. Giltighetstid"}</AppText.SubHeading>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.BodyText>
                    {`8.1 Användarvillkoren gäller tills vidare. Medalla har rätt att när som helst säga upp Användarens rätt att använda Tjänsten.`}
                </AppText.BodyText>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.SubHeading fontWeight={600} use={'h2'} margins={{
                    marginTop: '0px',
                    marginBottom: '0px'
                }} >{"9. Övriga villkor"}</AppText.SubHeading>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.BodyText>
                    {`9.1 Om Användaren bryter mot Avtalet har Medalla rätt att omedelbart stänga av Användaren från Tjänsten tills vidare eller avsluta Användarens användarkonto, utan något ansvar gentemot Användaren för detta.`}
                </AppText.BodyText>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.SubHeading fontWeight={600} use={'h2'} margins={{
                    marginTop: '0px',
                    marginBottom: '0px'
                }} >{"10. Tillämplig lag"}</AppText.SubHeading>
                <SizedBox height={theme.spacing.elementPadding} />

                <AppText.BodyText>
                    {`10.1 Användarvillkoren ska tolkas och tillämpas i enlighet med svensk lag.`}
                </AppText.BodyText>
            </AppContainer>
            <SizedBox height={theme.spacing.contentPaddingBig} />
            <AppFooter forceShow />
        </div>
    );
};




export default TermsPage;